<div class="sidebar-inner">
  <div class="sidebar-header">
    <h4>Results</h4>
  </div>
  <div class="sidebar-scroll">
    <ng-container *ngIf="!showDetectionResult">
      <div class="sidebar-select-slide" *ngIf="recordsData && recordsData.length && recordsData.length > 1 ">
        <h4>Select annotation</h4>
        <div class="tab-nav-scroll-custom">
          <nav mat-tab-nav-bar>
            <a mat-tab-link *ngIf="slide.details.aiCurrentApp === 'VISIOPHARM'"
              (click)="changeActiveFeedback((recordsData.length - 1),null)"
              [active]="selectedFeedbackIndex == (recordsData.length - 1)">
              All Annotations
            </a>
            <a mat-tab-link *ngFor="let feedback of allFeedbacks;let i = index"
              (click)="changeActiveFeedback(i,feedback.id)" [active]="selectedAnno == feedback.id">
              {{
              getCurrentTitleBody(feedback.body)?
              getCurrentTitleBody(feedback.body).value:'Annotation #'+(i+1)
              }}
            </a>
          </nav>
        </div>
      </div>
      <div class="sidebar-content">
        <div *ngIf='dataLoading' class="dataLoading">
          <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>
        <ng-container *ngIf='!dataLoading'>
          <div class="table-responsive" *ngIf="recordsData && recordsData.length; else dataEmpty">
            <table class="table table-primary">
              <thead *ngIf="slide.details.aiCurrentApp === 'CELL_COUNTING'">
                <tr>
                  <th>Cell Type</th>
                  <th>Count</th>
                  <th>Percent</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="slide.details.aiCurrentApp === 'CELL_COUNTING'">
                  <tr *ngFor="let record of recordsData" class="tr-cell-counting">
                    <th>{{record.cellTypeKey}}</th>
                    <td>{{record.value}}</td>
                    <td>{{record.percentage}}%</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="slide.details.aiCurrentApp === 'VISIOPHARM'">
                  <tr *ngFor="let record of recordsData[selectedFeedbackIndex].serializedVisoResult | jsonParse">
                    <th>{{record.Name}}</th>
                    <td>
                      <a [download]="record.Value" [href]="record.Value" class="download" matTooltip="download"
                        *ngIf="slide.details.aiAppDetails && slide.details.aiAppDetails.code === 'VISIO_Nuclei_Detection_IMC_AI';else otherValue">
                        <svg height="20" viewBox="0 0 20 20" width="20">
                          <path
                            d="M2.4,20A2.5,2.5,0,0,1,0,17.508V11.42a.294.294,0,0,1,.093-.2l3.07-5.918a.432.432,0,0,1,.419-.219H5.349a.489.489,0,0,1,0,.977H3.861L1.3,10.953h2.6A3.047,3.047,0,0,1,6.7,12.836a2.154,2.154,0,0,0,1.953,1.3h2.7a2.154,2.154,0,0,0,1.953-1.3,3.047,3.047,0,0,1,2.791-1.883h2.651L16.582,6.064h-1.93a.489.489,0,0,1,0-.977h2.233a.457.457,0,0,1,.442.244l2.6,5.893a.464.464,0,0,1,.07.2v6.088A2.5,2.5,0,0,1,17.6,20Zm7.279-8.68L6.512,7.973a.511.511,0,0,1,0-.588.453.453,0,0,1,.651-.1L9.535,9.781V.49a.466.466,0,1,1,.93,0V9.781l2.372-2.494a.446.446,0,0,1,.558,0,.507.507,0,0,1,.093.686L10.326,11.32a.284.284,0,0,1-.027.029.428.428,0,0,1-.624-.029Z"
                            fill="#7D4393" id="download-btn" />
                        </svg>
                      </a>
                      <ng-template #otherValue>
                        {{record.Value}}
                      </ng-template>
                    </td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="slide.details.aiCurrentApp === 'QUPATH'">
                  <ng-container *ngFor="let record of recordsData[selectedFeedbackIndex]">
                    <tr *ngIf="record.key !== 'Object ID'">
                      <th>{{record.key}}</th>
                      <td>{{record.value}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
              <tfoot *ngIf="slide.details.aiCurrentApp === 'CELL_COUNTING'">
                <tr>
                  <th></th>
                  <th colspan="2">
                    Total: <strong>{{total}}</strong>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <app-viewer-detection-result class="w-100 viewer-detection-result" #sideSheetResult *ngIf="showDetectionResult"
      [slide]="slide" (zoomEvent)="zoomToDetection($event)" [scrollToId]="scrollToId"></app-viewer-detection-result>
  </div>
  <div class="sidebar-footer"
    *ngIf="slide.details.aiCurrentApp === 'QUPATH'">
    <button class="w-100 mat-primary-light" mat-raised-button color="primary" (click)="showDetectionResults()"
      *ngIf="slide.details.aiCurrentApp === 'QUPATH'">
      {{showDetectionResult?'Hide Detection Results':'Show Detection Results'}}
    </button>
  </div>

  <ng-template #dataEmpty>
    <div class="data-empty m-0">
      <p>{{ 'general.NoFound' | translate }}</p>
    </div>
  </ng-template>
</div>
